import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: grid;
  place-content: center;
  background-color: rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  padding: 1rem;
  min-height: 20rem;

  & > * {
    font-family: var(--font-inter);
  }
`;
